<template>
  <component :is="component" :field="field" :value="value" />
</template>

<script>
export default {
  name: 'ExtraFieldPrint',
  props: {
    field: {
      type: Object,
    },
    value: {},
  },
  computed: {
    component() {
      let component = null
      component = () =>
        import(
          /* webpackChunkName: "extra_field" */ `./${this.field.type.snake2Pascal()}FieldPrint`
        ).catch(
          (component = () =>
            import(/* webpackChunkName: "extra_field" */ './TextFieldPrint')),
        )
      return component
    },
  },
}
</script>

<style scoped></style>
